import { createAction } from '@reduxjs/toolkit';
export const UPDATE_ANALYTIC_DOMAIN_SETTINGS = 'UPDATE_ANALYTIC_DOMAIN_SETTINGS';
export const updateAnalyticDomainSettingsAction = createAction(UPDATE_ANALYTIC_DOMAIN_SETTINGS);